<template>
  <div class="print-results max-height">
    <div class="print-results-wrapper">
      <date-picker v-model="dateResults" :clearable="false"
                   lang="en" :editable="false"
                   :not-after="new Date()"
                   :not-before="setDateFrom">
        <div slot="calendar-icon" class="calendar-wrapper">
          <i class="n-i n-i-calendar center-xy"></i>
        </div>
      </date-picker>
      <button @click="fetchResults"
              :class="{'disabledPrint': disabledPrint}"
              :disabled="disabledPrint">{{'print' | translate}}</button>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import { mapGetters } from 'vuex';
import OfferService from '../services/offer';
import Gateway from '../services/gateway';

export default {
  name: 'PrintResults',
  data() {
    return {
      dateResults: new Date(),
      date: new Date(),
      timeOffset: new Date().getTimezoneOffset() * 60,
      disabledPrint: false,
    };
  },
  components: { DatePicker },
  computed: {
    ...mapGetters([
      'gameId',
    ]),
    setDateFrom() {
      return new Date(this.date.setDate(this.date.getDate() - 30));
    },
  },
  methods: {
    /**
    * Fetch results offer
    */
    fetchResults() {
      this.disabledPrint = true;
      const data = {
        gameId: this.gameId,
        timeFrom: this.timeOffset < 0
          ? this.dateResults.getTime() - (parseInt(this.timeOffset, 10) * 1000)
          : this.dateResults.getTime() + (parseInt(this.timeOffset, 10) * 1000),
        offset: this.timeOffset,
      };
      OfferService.getResults(data).then((response) => {
        this.printResults(response.data.downloadUrl);
      });
    },
    printResults(results) {
      const actionData = {
        message: 'Peripherals.PrintA4',
        data: {
          documentUrl: results,
        },
      };
      Gateway.sendMessage(actionData.message, actionData.data);
      setTimeout(() => {
        this.disabledPrint = false;
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
  .print-results {
    position: relative;
    z-index: 3;
  }
  .print-results-wrapper {
    display: flex;
    flex: 1;
    flex-direction: column;
  }
  .calendar-wrapper {
    background-color: #6c7584;
    color: #fff;
    height: 100%;
    position: relative;
  }
</style>
